import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Memphis or New Orleans needed",
      "Ideal for Delta agricultural exporters with commodity trade trips",
      "Perfect for DSU students with study abroad deadlines",
      "Great for Mississippi Delta church mission groups",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Greenville post offices",
      "Good for planned international trips from the Delta",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Greenville or Cleveland USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: New Orleans (~4 hrs south)",
      "NPIC appointment required before traveling to either agency",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function GreenvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Greenville, MS"
      introText="Greenville travelers — Delta agricultural exporters with commodity trade trips to Brazil, China, and Southeast Asia, Delta State University students with study abroad acceptances, Mississippi River port workers with international shipping assignments, and Washington County church mission groups heading to Central America and Africa — have several options for getting a passport fast. Here is how they compare, and why most Mississippi Delta residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to New Orleans."
      options={options}
      emergencyDescription="Greenville does not have its own regional passport agency. The closest is New Orleans (~4 hrs south via I-55). For life-or-death emergencies — including medical travel, bereavement, and documented urgent departures — call NPIC at 1-877-487-2778 to book an appointment. No walk-ins accepted at the agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Greenville does not have a regional passport agency — the closest are Memphis and New Orleans. Not all applicants qualify for Regional Agency Processing."
    />
  );
}